
// import { getJobDetail } from "./jobDetailService";
// import { getJobInspectionPhotos } from "./jobMapService";
// import { getJobs } from "../components/jobService";

// /*
//  * Test Job ID
//  */
// export const TEST_JOB_ID = 22423;

// /*
//  * ============================================================
//  * JOB DETAIL ROLE PERMISSIONS
//  * ============================================================
//  *
//  * INTERNAL + ADMIN
//  *   -> Everything visible
//  *
//  * CUSTOMER + ADMIN
//  *   -> Owner, Snapper's Applications and Transactions hidden
//  *
//  * CUSTOMER + BM
//  *   -> Owner, Snapper's Applications and Transactions hidden
//  */
// export const getJobDetailPermissions = () => {
//   let user = null;

//   try {
//     const storedUser =
//       localStorage.getItem("user") ||
//       localStorage.getItem("localUser") ||
//       localStorage.getItem("currentUser");

//     if (storedUser) {
//       user = JSON.parse(storedUser);
//     }
//   } catch (error) {
//     console.error("[JOB DETAIL] Failed to read user:", error);
//   }

//   const organizationType = String(
//     user?.organization_type ||
//     user?.organizationType ||
//     user?.organization?.organization_type ||
//     user?.organization?.organizationType ||
//     ""
//   ).toUpperCase();

//   const role = String(
//     user?.org_role ||
//     user?.orgRole ||
//     user?.role ||
//     user?.user_type ||
//     user?.userType ||
//     ""
//   ).toUpperCase();

//   const isInternalAdmin =
//     organizationType === "INTERNAL" &&
//     role === "ADMIN";

//   const isCustomerAdmin =
//     organizationType === "CUSTOMER" &&
//     role === "ADMIN";

//   const isCustomerBM =
//     organizationType === "CUSTOMER" &&
//     role === "BM";

//   /*
//    * INTERNAL + ADMIN
//    * Everything is visible.
//    */
//   if (isInternalAdmin) {
//     return {
//       showOwner: true,
//       showSnapperApplications: true,
//       showTransactions: true,
//     };
//   }

//   /*
//    * CUSTOMER + ADMIN
//    * CUSTOMER + BM
//    * Last three sections are hidden.
//    */
//   if (isCustomerAdmin || isCustomerBM) {
//     return {
//       showOwner: false,
//       showSnapperApplications: false,
//       showTransactions: false,
//     };
//   }

//   /*
//    * Safe default.
//    *
//    * If role information is unavailable, don't expose
//    * Owner/Snapper/Transactions.
//    */
//   return {
//     showOwner: false,
//     showSnapperApplications: false,
//     showTransactions: false,
//   };
// };

// /*
//  * ============================================================
//  * GET JOB DETAIL TEST DATA
//  * ============================================================
//  */
// export const getJobDetailTestData = async (jobId = TEST_JOB_ID) => {
//   if (!jobId) {
//     throw new Error("Job ID is required.");
//   }

//   console.log("[JOB DETAIL TEST] Loading Job ID:", jobId);

//   try {
//     const [jobResponse, photosResponse] = await Promise.all([
//       getJobDetail(jobId),
//       getJobInspectionPhotos(jobId),
//     ]);

//     console.log("[JOB DETAIL TEST] Job API Response:", jobResponse);
//     console.log("[JOB DETAIL TEST] Photos API Response:", photosResponse);

//     const photos =
//   photosResponse?.images ||
//   photosResponse?.photos ||
//   photosResponse?.data ||
//   [];

// const videos = Array.isArray(photosResponse?.videos)
//   ? photosResponse.videos
//   : [];

// console.log("[JOB DETAIL] Images:", photos);
// console.log("[JOB DETAIL] Videos:", videos);

// const permissions = getJobDetailPermissions();

// console.log("[JOB DETAIL] Permissions:", permissions);

// return {
//   job: jobResponse || {},
//   photos: Array.isArray(photos) ? photos : [],
//   videos,
//   permissions,
// };
//   } catch (error) {
//     console.error("[JOB DETAIL TEST] API ERROR:", error);
//     throw error;
//   }
// };

// /*
//  * ============================================================
//  * GET PHOTO URL
//  * ============================================================
//  */
// export const getInspectionPhotoUrl = (photo) => {
//   if (!photo) {
//     return null;
//   }

//   if (typeof photo === "string") {
//     return photo;
//   }

//   return (
//     photo.url ||
//     photo.fileUrl ||
//     photo.image_url ||
//     photo.imageUrl ||
//     photo.src ||
//     photo.path ||
//     null
//   );
// };
// export const getInspectionMediaUrl = (media) => {
//   if (!media) {
//     return null;
//   }

//   // Direct string URL
//   if (typeof media === "string") {
//     return media;
//   }

//   // Video structure:
//   // url: {
//   //   url: "https://....mp4",
//   //   thumbnail: "..."
//   // }
//   if (media?.url && typeof media.url === "object") {
//     return media.url.url || null;
//   }

//   // Normal image/media structure
//   return (
//     media.url ||
//     media.fileUrl ||
//     media.image_url ||
//     media.imageUrl ||
//     media.src ||
//     media.path ||
//     null
//   );
// };

// export const isInspectionVideo = (media) => {
//   if (!media) {
//     return false;
//   }

//   const url = getInspectionMediaUrl(media);

//   return (
//     media.type === "video" ||
//     media.media_type === "video" ||
//     media.mime_type?.startsWith("video/") ||
//     /\.(mp4|webm|ogg|mov|m4v)(\?|$)/i.test(url || "")
//   );
// };
// /*
//  * ============================================================
//  * GENERATE JOB REPORT API CALL
//  * ============================================================
//  */
// const API_URL = process.env.REACT_APP_API_URL || "http://localhost:8000";

// export const generateJobReport = async (job) => {
//   if (!job?.id) {
//     throw new Error("Job ID is required for report generation.");
//   }

//   console.log("[REPORT] Job Detail ID:", job.id);

//   const jobsResponse = await getJobs();
//   const jobs = jobsResponse?.data || [];

//   const reportJob = jobs.find(
//     (item) => Number(item.id) === Number(job.id)
//   );

//   if (!reportJob) {
//     console.error(
//       "[REPORT] Could not find job in Reports job mapping:",
//       job.id
//     );

//     throw new Error(
//       `Could not find report mapping for Job ID ${job.id}.`
//     );
//   }

//   if (!reportJob.messageJobId) {
//     console.error("[REPORT] messageJobId missing:", reportJob);

//     throw new Error(`messageJobId is missing for Job ID ${job.id}.`);
//   }

//   console.log("[REPORT] Report Job Mapping:", reportJob);

//   const payload = {
//     id: reportJob.id,
//     message_job_id: reportJob.messageJobId,
//     category_id:
//       typeof job.category_id === "number"
//         ? job.category_id
//         : typeof job.categoryId === "number"
//         ? job.categoryId
//         : null,
//     images_per_row: 4,
//   };

//   console.log("[REPORT] Final Payload:", payload);

//   const token =
//     localStorage.getItem("token") || localStorage.getItem("jwt");

//   const response = await fetch(`${API_URL}/api/reports/generate`, {
//     method: "POST",
//     headers: {
//       "Content-Type": "application/json",
//       ...(token
//         ? {
//             Authorization: `Bearer ${token}`,
//           }
//         : {}),
//     },
//     body: JSON.stringify(payload),
//   });

//   const result = await response.json();

//   console.log("[REPORT] API Response:", result);

//   if (!response.ok || !result?.success) {
//     const errorMessage =
//       result?.error || result?.detail || "Failed to generate report.";

//     throw new Error(
//       typeof errorMessage === "string"
//         ? errorMessage
//         : JSON.stringify(errorMessage)
//     );
//   }

//   return result;
// };
import { getJobDetail } from "./jobDetailService";
import { getJobInspectionPhotos } from "./jobMapService";

/*
 * Test Job ID
 */
export const TEST_JOB_ID = 22423;

/*
 * ============================================================
 * JOB DETAIL ROLE PERMISSIONS
 * ============================================================
 *
 * INTERNAL + ADMIN
 *   -> Everything visible
 *
 * CUSTOMER + ADMIN
 *   -> Owner, Snapper's Applications and Transactions hidden
 *
 * CUSTOMER + BM
 *   -> Owner, Snapper's Applications and Transactions hidden
 */
export const getJobDetailPermissions = () => {
  let user = null;

  try {
    const storedUser =
      localStorage.getItem("user") ||
      localStorage.getItem("localUser") ||
      localStorage.getItem("currentUser");

    if (storedUser) {
      user = JSON.parse(storedUser);
    }
  } catch (error) {
    console.error("[JOB DETAIL] Failed to read user:", error);
  }

  const organizationType = String(
    user?.organization_type ||
    user?.organizationType ||
    user?.organization?.organization_type ||
    user?.organization?.organizationType ||
    ""
  ).toUpperCase();

  const role = String(
    user?.org_role ||
    user?.orgRole ||
    user?.role ||
    user?.user_type ||
    user?.userType ||
    ""
  ).toUpperCase();

  const isInternalAdmin =
    organizationType === "INTERNAL" &&
    role === "ADMIN";

  const isCustomerAdmin =
    organizationType === "CUSTOMER" &&
    role === "ADMIN";

  const isCustomerBM =
    organizationType === "CUSTOMER" &&
    role === "BM";

  /*
   * INTERNAL + ADMIN
   * Everything is visible.
   */
  if (isInternalAdmin) {
    return {
      showOwner: true,
      showSnapperApplications: true,
      showTransactions: true,
    };
  }

  /*
   * CUSTOMER + ADMIN
   * CUSTOMER + BM
   * Last three sections are hidden.
   */
  if (isCustomerAdmin || isCustomerBM) {
    return {
      showOwner: false,
      showSnapperApplications: false,
      showTransactions: false,
    };
  }

  /*
   * Safe default.
   *
   * If role information is unavailable, don't expose
   * Owner/Snapper/Transactions.
   */
  return {
    showOwner: false,
    showSnapperApplications: false,
    showTransactions: false,
  };
};

/*
 * ============================================================
 * GET JOB DETAIL TEST DATA
 * ============================================================
 */
export const getJobDetailTestData = async (jobId = TEST_JOB_ID) => {
  if (!jobId) {
    throw new Error("Job ID is required.");
  }

  console.log("[JOB DETAIL TEST] Loading Job ID:", jobId);

  try {
    const [jobResponse, photosResponse] = await Promise.all([
      getJobDetail(jobId),
      getJobInspectionPhotos(jobId),
    ]);

    console.log("[JOB DETAIL TEST] Job API Response:", jobResponse);
    console.log("[JOB DETAIL TEST] Photos API Response:", photosResponse);

    const photos =
      photosResponse?.images ||
      photosResponse?.photos ||
      photosResponse?.data ||
      [];

    const videos = Array.isArray(photosResponse?.videos)
      ? photosResponse.videos
      : [];

    console.log("[JOB DETAIL] Images:", photos);
    console.log("[JOB DETAIL] Videos:", videos);

    const permissions = getJobDetailPermissions();

    console.log("[JOB DETAIL] Permissions:", permissions);

    return {
      job: {
        ...(jobResponse || {}),

        // Keep the message job ID already resolved by
        // the Inspection Photos API.
        message_job_id:
          photosResponse?.message_job_id ||
          photosResponse?.messageJobId ||
          null,
      },

      photos: Array.isArray(photos) ? photos : [],
      videos,
      permissions,

      // Keep the complete inspection response available
      // without changing discrepancy detection.
      inspectionData: photosResponse || {},
    };
  } catch (error) {
    console.error("[JOB DETAIL TEST] API ERROR:", error);
    throw error;
  }
};

/*
 * ============================================================
 * GET PHOTO URL
 * ============================================================
 */
export const getInspectionPhotoUrl = (photo) => {
  if (!photo) {
    return null;
  }

  if (typeof photo === "string") {
    return photo;
  }

  return (
    photo.url ||
    photo.fileUrl ||
    photo.image_url ||
    photo.imageUrl ||
    photo.src ||
    photo.path ||
    null
  );
};

export const getInspectionMediaUrl = (media) => {
  if (!media) {
    return null;
  }

  // Direct string URL
  if (typeof media === "string") {
    return media;
  }

  // Video structure:
  // url: {
  //   url: "https://....mp4",
  //   thumbnail: "..."
  // }
  if (media?.url && typeof media.url === "object") {
    return media.url.url || null;
  }

  // Normal image/media structure
  return (
    media.url ||
    media.fileUrl ||
    media.image_url ||
    media.imageUrl ||
    media.src ||
    media.path ||
    null
  );
};

export const isInspectionVideo = (media) => {
  if (!media) {
    return false;
  }

  const url = getInspectionMediaUrl(media);

  return (
    media.type === "video" ||
    media.media_type === "video" ||
    media.mime_type?.startsWith("video/") ||
    /\.(mp4|webm|ogg|mov|m4v)(\?|$)/i.test(url || "")
  );
};

/*
 * ============================================================
 * GENERATE JOB REPORT API CALL
 * ============================================================
 */
const API_URL = process.env.REACT_APP_API_URL || "http://localhost:8000";

export const generateJobReport = async (job) => {
  if (!job?.id) {
    throw new Error("Job ID is required for report generation.");
  }

  console.log("[REPORT] Job Detail ID:", job.id);

  /*
   * IMPORTANT:
   * Do NOT call getJobs() here.
   *
   * The Inspection Photos API has already resolved
   * the TechZeus message job ID while loading Job Detail.
   */

  const messageJobId =
    job.message_job_id ||
    job.messageJobId ||
    job.snapper?.jobId ||
    null;

  if (!messageJobId) {
    console.error(
      "[REPORT] message_job_id missing from Job Detail:",
      job
    );

    throw new Error(
      `message_job_id is missing for Job ID ${job.id}.`
    );
  }

  const payload = {
    id: Number(job.id),

    // Use the ID already obtained by Inspection Photos API
    message_job_id: Number(messageJobId),

    category_id:
      typeof job.category_id === "number"
        ? job.category_id
        : typeof job.categoryId === "number"
        ? job.categoryId
        : null,

    images_per_row: 4,
  };

  console.log("[REPORT] Direct Payload:", payload);

  const token =
    localStorage.getItem("token") ||
    localStorage.getItem("jwt");

  const response = await fetch(
    `${API_URL}/api/reports/generate`,
    {
      method: "POST",

      headers: {
        "Content-Type": "application/json",

        ...(token
          ? {
              Authorization: `Bearer ${token}`,
            }
          : {}),
      },

      body: JSON.stringify(payload),
    }
  );

  const result = await response.json();

  console.log("[REPORT] API Response:", result);

  if (!response.ok || !result?.success) {
    const errorMessage =
      result?.error ||
      result?.detail ||
      "Failed to generate report.";

    throw new Error(
      typeof errorMessage === "string"
        ? errorMessage
        : JSON.stringify(errorMessage)
    );
  }

  return result;
};